'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import { styled } from 'styled-components';
import { ButtonGroup as AuiButtonGroup } from '../ButtonGroup';
import { SimpleBlockContext } from './SimpleBlockContext';
import { Container } from './elements';
const StyledButtonGroup = styled(AuiButtonGroup).withConfig({
  componentId: "aui__sc-olw5rp-0"
})(["align-items:flex-end;gap:var(--aui-spacing-200);--flex-grow-value:", ";", ":not(:has([data-aui='price'])) &{flex-grow:var(--flex-grow-value);}"], ({
  $shouldGrow
}) => $shouldGrow ? '1' : '0', Container);

/** @deprecated use SimpleBlock.ActionGroup instead */
export const ButtonGroup = ({
  children,
  ...props
}) => {
  const {
    alignment,
    contentHeight
  } = useContext(SimpleBlockContext);
  const alignmentMapping = {
    left: 'start',
    center: 'center'
  };
  return /*#__PURE__*/React.createElement(StyledButtonGroup, _extends({
    alignment: alignmentMapping[alignment],
    $shouldGrow: contentHeight === 'fill'
  }, props), children);
};